<h2 class="card-title">Linha do tempo dos atos</h2>
<p class="intro">
  O que cada contrato, alteração ou ata mudou, do mais recente para o mais antigo. Clique na origem
  de uma mudança para abrir o documento na página.
</p>

@if (missingActs().length > 0) {
  <p class="missing">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    Faltam atos para fechar a sequência: {{ missingActs().join(', ') }}. Envie esses documentos ao
    Data Room.
  </p>
}

@if (rows().length === 0) {
  <p class="empty">Nenhum ato lido ainda.</p>
} @else {
  <ol class="timeline">
    @for (row of rows(); track row.act.actId) {
      <li
        [id]="'charter-act-' + row.act.actId"
        class="timeline__item"
        [class.timeline__item--highlighted]="row.act.actId === highlightedActId()">
        <app-charter-act-item
          [act]="row.act"
          [summary]="row.summary"
          [changes]="row.changes"
          [actDate]="row.actDate"
          [isCurrent]="row.act.actId === currentActId()"
          [isInternal]="isInternal()"
          [isAdmin]="isAdmin()"
          [openingDocumentId]="openingDocumentId()"
          (openInDataRoom)="openInDataRoom.emit($event)" />
      </li>
    }
  </ol>
}
